import StaffListView from '../../components/StaffListView';

StaffListScreen.propTypes = {};

function StaffListScreen(props) {
  return (
    <div className="container-fluid px-4 my-4">
      <StaffListView showFullUI={true} />
    </div>
  );
}

export default StaffListScreen;
